import { ActionTree } from 'vuex';
import { RootState } from '../types';
import {AxiosState, ActionError, ICancelerProp} from './types';

interface ActionsType {
    REPLACE_CANCELER: ({commit}: any, payload: ICancelerProp) => void;
    PUSH_CANCELER: ({commit}: any, payload: ICancelerProp) => void;
    REMOVE_CANCELER: ({commit}: any, key: string) => void;
    RUN_CANCELER: ({commit}: any, key: string) => void;
    RUN_ALL_CANCELERS: ({commit}: any) => void;
    CLEAR_ALL_CANCELERS: ({commit}: any) => void;
}

export const actions: ActionTree<AxiosState, RootState> & ActionsType = {
    REPLACE_CANCELER: async ({commit, dispatch}: any, payload: ICancelerProp) => {
        try {
            await dispatch('RUN_CANCELER', payload.key);
        } catch (err) {
            err.storeType = err.type;
            err.type = ActionError.ERR_VUEX_DISPATCH;
            throw err;
        }

        try {
            await commit('PUSH_CANCELER', payload);
        } catch (err) {
            err.storeType = err.type;
            err.type = ActionError.ERR_VUEX_SETTING;
            throw err;
        }
    },
    PUSH_CANCELER: async ({commit}: any, payload: ICancelerProp) => {
        try {
            await commit('PUSH_CANCELER', payload);
        } catch (err) {
            err.storeType = err.type;
            err.type = ActionError.ERR_VUEX_SETTING;
            throw err;
        }
    },
    REMOVE_CANCELER: async ({commit}: any, key: string) => {
        try {
            await commit('REMOVE_CANCELER', key);
        } catch (err) {
            err.storeType = err.type;
            err.type = ActionError.ERR_VUEX_SETTING;
            throw err;
        }
    },
    RUN_CANCELER: async ({commit}: any, key: string) => {
        try {
            await commit('RUN_CANCELER', key);
        } catch (err) {
            err.storeType = err.type;
            err.type = ActionError.ERR_VUEX_SETTING;
            throw err;
        }
    },
    RUN_ALL_CANCELERS: async ({commit}: any) => {
        try {
            await commit('RUN_ALL_CANCELERS');
        } catch (err) {
            err.storeType = err.type;
            err.type = ActionError.ERR_VUEX_SETTING;
            throw err;
        }
    },
    CLEAR_ALL_CANCELERS: async ({commit}: any) => {
        try {
            await commit('CLEAR_ALL_CANCELERS');
        } catch (err) {
            err.storeType = err.type;
            err.type = ActionError.ERR_VUEX_SETTING;
            throw err;
        }
    },

};
